<template>
    <div class="mine-module">
        <div class="HomeTitle">
            <!-- <custom-back></custom-back> -->
            <div class="head">
                <div class="openhead">
                    <img class="headimg" src="https://staticpos.beautyfarm.com.cn/pos_wechat/shop/head.png" alt="">

                </div>
                <div class="info">
                    <div class="infoname">
                        <div>{{ myData.empName }}</div>
                        <div class="post">{{ myData.empPost }}</div>
                    </div>
                    <div class="infostore" v-if="myData.storeName">{{ myData.storeName }}</div>
                </div>
            </div>
            <div class="tab-tit-box flex flex-around">
                <div :class="`tab-tit ${tabActive == 0 ? 'active' : ''}`" @click="tabClick('0')">
                    本月
                </div>
                <div :class="`tab-tit ${tabActive == 1 ? 'active' : ''}`" @click="tabClick('1')">
                    上月
                </div>
            </div>
        </div>
        <div class="flex-col padding-left padding-right">
            <div style="margin: 25px 0 20px;font-size:17px">
                <img class="icon" src="../../../assets/img/icons.png" alt="">
                数据统计
            </div>
            <div class="card-list flex">
                <div class="card-item">
                    <div v-if="data.employ" class="rate">{{ data.employ }} </div>
                    <div v-else class="rate">--</div>
                    <!-- <div class="progress-container">
                    <div class="progress-value" style="width: {{ data.employ }}%"></div>
                </div> -->
                    <div class="name"> 使用情况 </div>
                </div>
                <div class="card-item">
                    <div v-if="data.task" class="rate">{{ data.task }} </div>
                    <div v-else class="rate">--</div>
                    <!-- <div class="progress-container">
                    <div class="progress-value" style="width: {{ data.task }}%"></div>
                </div> -->
                    <div class="name"> 所有任务 </div>
                </div>
                <div class="card-item" @click="toRepairList">
                    <div v-if="data.feedback" class="rate">{{ data.feedback }} </div>
                    <div v-else class="rate">--</div>
                    <!-- <div class="progress-container">
                    <div class="progress-value" style="width: {{ data.feedback }}%"></div>
                </div> -->
                    <div class="name"> 反馈平均处理时长 </div>
                </div>
                <div class="card-item" @click="toComplaintList">
                    <div v-if="data.complaint" class="rate">{{ data.complaint }} </div>
                    <div v-else class="rate">--</div>
                    <!-- <div class="progress-container">
                    <div class="progress-value" style="width: {{ data.complaint }}%"></div>
                </div> -->
                    <div class="name"> 投诉平均处理时长 </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from 'vant'

    export default {
        name: "storeInfoStatisticsfrom",
        data() {
            return {
                tabActive: 0,
                data: {},
                myData: {},
            };
        },
        mounted() {
            this.getData();
            this.getMyData();
        },
        methods: {
            // 个人信息
            getMyData() {
                return request({
                    url: `/my/myData`,
                    method: "get",
                }).then((res) => {
                    this.myData = res.data;

                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            // 统计数据
            getData() {
                let type = Number(this.tabActive) + 1;
                return request({
                    url: `/work/workNoData?type=${type}`,
                    method: "get",
                }).then((res) => {
                    this.data = res.data
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
            },
            tabClick(num) {
                this.tabActive = num
                this.getData();
            },
            // 跳转反馈列表
            toRepairList() {
                this.$router.push({ name: "repairOrderList", query: { type: 1 } });
            },
            // 跳转投诉列表
            toComplaintList() {
                this.$router.push({ name: "repairOrderList", query: { type: 3 } });
            },
        },
    };
</script>

<style scoped>
    .HomeTitle {
        width: 750px;
        min-height: 251px;
        background: linear-gradient(90deg, #1db2e4 0%, #4ae0d9 100%);
        color: #fff;
        box-sizing: border-box;
        overflow-x: hidden;
        font-size: 34px;
    }

    .head {
        margin-left: 30px;
        margin-top: 49px;
        width: 100%;
        display: flex;
        justify-content: left;
        align-items: center;
    }

    .openhead {
        width: 130px;
        height: 130px;
    }

    .head .headimg {
        width: 130px;
        height: 130px;
        display: block;
        overflow: hidden;
        border-radius: 50%;
    }

    .info {
        flex: 1;
        height: 130px;
        padding-left: 30px;
        box-sizing: border-box;
    }

    .infoname {
        height: 50%;
        font-weight: bold;
        font-size: 34px;
        line-height: 50%;
        display: flex;
        align-items: center;
    }

    .infoname .post {
        font-size: 26px;
        margin-left: 20px;
        color: #d5f3f8;
        background-color: rgba(0, 0, 0, 0.2);
        border-radius: 25px;
        min-width: 98px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        padding: 0 10px;
    }

    .infostore {
        height: 50%;
        display: flex;
        align-items: center;
        font-size: 26px;
        color: #d5f3f8;
    }

    .tab-tit-box {
        height: 70px;
        width: 100%;
        margin-top: 40px;
        padding: 0 30px;
    }

    .tab-tit {
        width: 70px;
        height: 48px;
        font-size: 34px;
        position: relative;
    }

    .tab-tit.active:after {
        content: "";
        display: block;
        position: relative;
        bottom: -7px;
        left: 10%;
        width: 50px;
        height: 8px;
        background: #fff;
        border-radius: 4px;
    }

    .card-list {
        flex-wrap: wrap;
    }

    .card-item {
        width: 330px;
        height: 227px;
        background: #ffffff;
        box-shadow: 0px 2px 26px 0px rgba(2, 2, 2, 0.08);
        border-radius: 30px;
        margin-bottom: 20px;
        padding: 36px 30px 40px;
    }

    .card-item:nth-child(2n) {
        margin-left: 30px;
    }

    .card-item .rate {
        font-size: 60px;
        font-weight: 700;
        color: #35434c;
        line-height: 84px;
    }

    .card-item .name {
        font-size: 26px;
        color: #a0acb5;
        line-height: 37px;
    }

    .progress-container {
        width: 270px;
        height: 10px;
        background: #f6f6f6;
        border-radius: 8px;
        position: relative;
        margin: 10px 0;
    }

    .progress-container .progress-value {
        position: absolute;
        height: 10px;
        border-radius: 8px;
        top: 0;
        left: 0;
        background: #2fd0d5;
    }

    .icon {
        width: 40px;
        height: 40px;
        vertical-align: middle;
    }
</style>
